import {ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {MultiOptionConfig, OptionSourceData} from '../multi-option.config';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'mydocma-form-multi-option-field',
    templateUrl: './multi-option.component.html',
    styleUrls: ['./multi-option.component.scss']
})
export class MultiOptionComponent extends BaseFieldComponent<MultiOptionConfig> implements OnInit {

    public source: Array<Record<string, string | OptionSourceData>> = []
    public sourceValues: Array<string | OptionSourceData> = [];
    public readonly staticCssClass = 'mydocma-multi-option';

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher,element,renderer);

    }

    ngOnInit() {
        super.ngOnInit();
        this.setSource();
    }


    private setSource() {

        this.source= [];
        Object.keys(this.fieldWrapper.config.source)
            .forEach(key=> {
                this.source.push({key, value: this.fieldWrapper.config.source[key]});
                this.setSourceReadonly(key, (this.fieldWrapper.config.source[key] as OptionSourceData).readonly || this.fieldWrapper.config.readonly);
            }) ;


    }

    public onFieldWrapperUpdated() {
        super.onFieldWrapperUpdated();
        this.setSource();
    }

    public arrayConverter(value) {
        return Object.keys(value);
    }

    public setSourceReadonly(key: string, readonly: boolean)
    {
        if (this.fieldWrapper.config.readonly || readonly) {
            (this.dynamicFormService.getFormValue().controls[this.fieldWrapper.config.name] as FormGroup)?.controls[key]?.disable();
        }
        else {
            (this.dynamicFormService.getFormValue().controls[this.fieldWrapper.config.name] as FormGroup)?.controls[key]?.enable();
        }
    }
}

